<template>
  <modal
    header-text=""
    :button-text="$t('global.change')"
    @action="$emit('setProfile')"
    @close="$emit('cancel')"
  >
    <div :class="$style.inputContainer">
      {{ $t('modal.areYouSureYouWantToEditProfile') }}
    </div>
  </modal>
</template>

<script>
  import Modal from '@/components/common/modal/settings-modal.vue';

  export default {
    components: { Modal },
  };
</script>

<style lang="scss" module>
  .inputContainer {
    font-size: 13px;
    margin: 5px;
  }
</style>
